import './style.css';
import {useContext} from "react";
import {AppContext} from "../../../context/AppProvider";
const ProductSearchItem = ({ product }) =>
{
    const {appData} = useContext(AppContext);

    if(product.unit ==='kg')
    {
        product.stock = (product.stock || 0) / 1000;
    }

    return (
        <div className="product-search-item">
            <div className="product-item-image">
                {product.image ? (
                    <img src={product.image} alt={product.title} />
                ) : (
                    <div className="no-image">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                            <circle cx="8.5" cy="8.5" r="1.5" />
                            <polyline points="21 15 16 10 5 21" />
                        </svg>
                    </div>
                )}
            </div>
            <div className="product-item-info">
                <div className="product-item-title">{product.title} <span className={'color-blue'}>{product.attribute_label}</span></div>
                <div className="product-item-code">{product.code}</div>
                <div className="product-item-stock">
                    Tồn: <span className="stock-value">{product.stock || 0} {appData['units'][product.unit]?.label}</span>
                </div>
            </div>
        </div>
    );
};
export default ProductSearchItem;
